// JS for block-specific behavior only
console.log('res block demo block loaded');